import TitleBlock from '@anm/components/TitleBlock';
import styled from 'styled-components';

export const TitleBlockWrapper = styled(TitleBlock)`
  margin-bottom: 24px;
`;


export const Container = styled.div`
  padding: 16px;
  margin-bottom: 8px;

  background: #fff4db;
  border: 1px solid #fcbd26;
  border-radius: 10px;
  font-size: 14px;
  line-height: 22px;
  color: #292a2b;

  > ul {
    list-style: disc;
    > li {
      margin-left: 20px;
    }
  }
`;

export const Bold = styled.span`
  font-weight: 700;
`;

const Wrapper = styled.div``;

export default Wrapper;
